import { useCallback, useState } from "react";

export function useHistoryBulkDelete() {
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [checkedList, setCheckedList] = useState<string[]>([]);
  const [confirmingBulk, setConfirmingBulk] = useState(false);

  const openBulkDelete = useCallback(() => {
    setShowCheckboxes(true);
    setCheckedList([]);
    setConfirmingBulk(false);
  }, []);

  const resetBulkDelete = useCallback(() => {
    setShowCheckboxes(false);
    setCheckedList([]);
    setConfirmingBulk(false);
  }, []);

  return {
    showCheckboxes,
    setShowCheckboxes,
    checkedList,
    setCheckedList,
    confirmingBulk,
    setConfirmingBulk,
    openBulkDelete,
    resetBulkDelete,
  };
}
